import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { DataTable, DataRow, DataCell } from 'components/basic/DataTable';
import * as Clients from '../../client/ApiClient';
import { connect } from 'react-redux';
import { ApplicationState } from 'store';
import { Row, Col, Badge, Button } from 'reactstrap';

import './User.scss';
import CreateApiKeyModal from '../basic/modals/CreateApiKeyModal';

interface IApiKeysProps extends RouteComponentProps {
    currentUser: Clients.IUserLoginDetailsModel | undefined;
    id: string;
};

type ApiKeysPageState = {
    apikeys: Clients.ApiKeyModel[];
    sort: boolean;
    modalOpen: boolean;
    submitDisabled: boolean;
    ApiKey: string | undefined;
    revoke: boolean;
}

class ApiKeysPage extends React.Component<IApiKeysProps, ApiKeysPageState>{
    private readonly client: Clients.ApiKeyClient = new Clients.ApiKeyClient();

    constructor(props: any) {
        super(props)
        this.state = {
            apikeys: [],
            sort: true,
            modalOpen: false,
            submitDisabled: false,
            ApiKey: undefined,
            revoke:true,
        }
    }

    componentDidMount() {
        this.getApiKeys();
    }

    getApiKeys() {
        this.client.getUserKeys(this.props.id!)
            .then(response => {
                if (response != null) {
                    this.setState({
                        apikeys: response,
                    })
                }
            })
            .catch(error => { })
    }

    sort(column: string) {
        const apikeys = this.state.apikeys.sort((a: any, b: any) => {
            let x = a[column]
            let y = b[column]
            if (typeof x === 'string' && typeof y === 'string') {
                x = x.toLowerCase().trim()
                y = y.toLowerCase().trim()
            }
            if (this.state.sort) {
                if (x < y) { return -1; }
                if (x > y) { return 1; }
            } else {
                if (x > y) { return -1; }
                if (x < y) { return 1; }
            }
            return 0
        })
        this.setState({ sort: !this.state.sort, apikeys });
    }

    createKey = (name: string | null, date: Date |null) => {
        this.setState({ submitDisabled: true }, () => {
            this.client.createUserKey(this.props.id!, name, date, this.props.currentUser!.id!)
                .then(response => {
                    this.setState({ ApiKey: response!.apiKey }, () => {
                        this.getApiKeys();
                    })
                })
                .catch(err => {
                    console.log(err)
                })
        })
    }

    revokeKey = (id: string) => {
        if (confirm('Are you sure, do you want to continue with revoking API Key?')) {
            this.client.revokeUserKey(id)
                .then(() => this.getApiKeys())
                .catch(err => {
                    console.log(err)
                })
        }
    }

    public render() {
        const revoke = this.state.revoke ? "Show All" : "Hide Revoke"

        return (
            <>
                <br />
                <Row>
                    <Col md={{ size: 9, offset: 1 }}>
                        <div>
                            <h2>API Keys</h2>
                            <h5>Create access keys for the API</h5>
                            <br />
                        </div>
                    </Col>
                    <Col md={{ size: 2 }}>
                        <Button className="submit-button-orange" type="button" onClick={() => this.setState({ modalOpen: true, submitDisabled:false })} >Create Api Key</Button>
                    </Col>
                </Row>
                <DataTable>
                    <thead>
                        <tr>
                            <th onClick={() => this.sort('name')} >Name<i className="fa fa-sort"></i></th>
                            <th onClick={() => this.sort('status')}>Status<i className="fa fa-sort"></i></th>
                            <th onClick={() => this.sort('usage')}>Usage<i className="fa fa-sort"></i></th>
                            <th onClick={() => this.sort('lifetime')}>Expiration<i className="fa fa-sort"></i></th>
                            <th onClick={() => this.sort('revoke')}>Action<i className="fa fa-sort"></i></th>
                            <th><label className="switch"><input type="checkbox" readOnly checked={!this.state.revoke} onClick={() => this.setState({ revoke: !this.state.revoke })} /><span className="slider round"></span></label>{revoke}</th>
                        </tr>
                    </thead>
                    <tbody className="nonEntity">
                        {this.state.apikeys
                            .filter(k => {
                                return !k.expired || !this.state.revoke 
                            })
                            .map(k => (
                                <DataRow key={k.id} id={k.id!}>
                                    <DataCell>{k.name}</DataCell>
                                    <DataCell><h5>{k.status === 'A' ? <Badge color="success">Active</Badge> : <Badge>Expired</Badge>}</h5></DataCell>
                                    <DataCell>{k.usage && k.usage!.toLocaleString()}</DataCell>
                                    <DataCell>{k.lifetime}</DataCell>
                                    <DataCell>
                                        <Button
                                            color={k.expired ? "secondary" : "danger"}
                                            size="sm"
                                            disabled={k.expired}
                                            onClick={() => this.revokeKey(k.id!)}
                                        >
                                            {k.expired ? "Revoked" : "Revoke" }
                                        </Button>
                                    </DataCell>
                                    <DataCell>
                                    </DataCell>
                                </DataRow>
                            ))}
                    </tbody>
                </DataTable>
                <CreateApiKeyModal isOpen={this.state.modalOpen} submitDisabled={this.state.submitDisabled} apikey={this.state.ApiKey} onSubmit={this.createKey} onClose={() => this.setState({ modalOpen: false, ApiKey: undefined })} />
            </>
        );
    }
}

export default connect(
    (state: ApplicationState) => {
        return {
            currentUser: state.authentication && state.authentication.currentUser,
            currentSelect: state.select && state.select.userCompany
        }
    },
)(withRouter(ApiKeysPage));